import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../redux/authSlice';

const PING_INTERVAL_MS = 300000; // Abbassare per testing (es. 10000)

export default function useServerStatus(pingUrl = '/api/status/ping') {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem('accessToken');
  const tenantId = localStorage.getItem('tenantId');

  //commentare quando effettui test
  useEffect(() => {
    if (!token || !tenantId) {
      dispatch(logout());
      navigate('/login');
      return;
    }
  })

  const [isServerOnline, setIsServerOnline] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    const pingServer = async () => {
      try {
        const headers = {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
          'x-tenant-id': tenantId,
        };

        const response = await fetch(pingUrl, {
          method: 'GET',
          headers,
          signal: controller.signal,
        });

        if (response.status === 200 || [401, 403].includes(response.status)) {
          setIsServerOnline(true); // Online anche se accesso negato
        } else {
          setIsServerOnline(false);
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          setIsServerOnline(false); // Errore di rete o fetch
        }
      }
    };

    pingServer();
    const interval = setInterval(pingServer, PING_INTERVAL_MS);

    return () => {
      controller.abort();
      clearInterval(interval);
    };
  }, [pingUrl, token, tenantId]);

  return isServerOnline;
};